module.exports = __webpack_public_path__ + "static/media/ellipsis.ceeb4013.svg";